import {MainMenuItem, MainMenuItemModel} from '@/components/custom/header/mainmenu/mainMenuItem'

interface MainMenuListProps {
    locale: string,
    menuItems: MainMenuItemModel[],
    activeMainMenuItem: any,
    setSubactive: (value: boolean) => void,
    setActiveMainMenuItem: (value: any) => void,
    setCurrentSubItems: (value: MainMenuItemModel[]) => void,
}

const MainMenuList = ({ locale, menuItems, activeMainMenuItem, setSubactive, setActiveMainMenuItem, setCurrentSubItems }: MainMenuListProps) => {
    return (
        <ul className='group hidden h-full flex-row items-stretch justify-start gap-4 space-x-1 text-sm font-bold uppercase tracking-widest lg:flex'>
            {menuItems.length > 0 &&
                menuItems.filter(item => item.active).map((item) => (
                    <MainMenuItem
                        key={item.id}
                        item={item}
                        locale={locale}
                        activeMainMenuItem={activeMainMenuItem}
                        setActiveMainMenuItem={setActiveMainMenuItem}
                        setSubactive={setSubactive}
                        setCurrentSubItems={setCurrentSubItems}
                    />
                ))}
        </ul>
    )
}

export { MainMenuList }
